export default __webpack_public_path__ + "static/media/a-icon-close.bb72cf0a.svg";